import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import en from './i18n/en.json'
import es from './i18n/es.json'

i18next
  .use(LanguageDetector)
  .init({
    fallbackLng: 'en',
    fallbackNS: ['translation'],
    debug: process.env.NODE_ENV !== 'production',
    resources: {
      es: {
        translation: es
      },
      en: {
        translation: en
      }
    }
  })

export default i18next
